export const FAVORITES_CATEGORY_ID = "__favorites__";
export const PRODUCT_FAVORITES_EVENT = "pos-product-favorites-updated";

function getFavoritesStorageKey(userId) {
	return "pos-product-favorites-" + userId;
}

export function loadFavoriteProductIds(userId) {
	if (!userId) return [];
	try {
		const stored = localStorage.getItem(getFavoritesStorageKey(userId));
		const parsed = JSON.parse(stored || "[]");
		return Array.isArray(parsed) ? parsed : [];
	} catch (error) {
		console.error("Errore lettura preferiti prodotti", error);
		return [];
	}
}

export function saveFavoriteProductIds(userId, favoriteProductIds) {
	if (!userId) return;
	localStorage.setItem(getFavoritesStorageKey(userId), JSON.stringify(favoriteProductIds));
	window.dispatchEvent(
		new CustomEvent(PRODUCT_FAVORITES_EVENT, {
			detail: { userId, favoriteProductIds },
		}),
	);
}

export function buildFavoriteCategory(filteredCategories, favoriteProductIds) {
	if (!Array.isArray(filteredCategories) || favoriteProductIds.length === 0) return null;

	const favoriteIdSet = new Set(favoriteProductIds.map((id) => Number(id)));
	const seenProductIds = new Set();
	const products = [];

	function getSortablePosition(value) {
		const numericValue = Number(value);
		return Number.isFinite(numericValue) ? numericValue : 999999;
	}

	for (const course of filteredCategories) {
		for (const category of course.categories || []) {
			for (const product of category.products || []) {
				const productId = Number(product?.id);
				if (!favoriteIdSet.has(productId) || seenProductIds.has(productId)) continue;
				seenProductIds.add(productId);
				products.push({
					product,
					categoryPosition: getSortablePosition(category?.position),
					productPosition: getSortablePosition(product?.position),
				});
			}
		}
	}

	if (products.length === 0) return null;

	products.sort((a, b) => {
		if (a.categoryPosition !== b.categoryPosition) return a.categoryPosition - b.categoryPosition;
		if (a.productPosition !== b.productPosition) return a.productPosition - b.productPosition;
		return String(a?.product?.name || "").localeCompare(String(b?.product?.name || ""));
	});

	return {
		id: FAVORITES_CATEGORY_ID,
		name: "Preferiti",
		products: products.map((entry) => entry.product),
	};
}

export function getFirstAvailableCategory(filteredCategories) {
	for (const course of filteredCategories || []) {
		for (const category of course.categories || []) {
			if (category) return category;
		}
	}
	return null;
}
